/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} View_DisplayInputs */

const en_view_display = /** @type {(inputs: View_DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Display options`)
};

const de_view_display = /** @type {(inputs: View_DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darstellung`)
};

/**
* | output |
* | --- |
* | "Display options" |
*
* @param {View_DisplayInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const view_display = /** @type {((inputs?: View_DisplayInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<View_DisplayInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_view_display(inputs)
	return en_view_display(inputs)
});